module.exports = __webpack_public_path__ + "static/sergio-6b1e643e7827ab67607fa36492ecbead.jpg";